<template>
  <div>
    <div class="form-group">
      <label>پلاک</label>
      <div class="plate">
        <input
          type="text"
          maxlength="2"
          class="plate-two plate-commons"
          v-model="plate.cityNumber"
          @change="updateValue()"
        />
        <select
          class="plate-alphabet plate-commons"
          name=""
          id=""
          @change="updateValue()"
          v-model="plate.alphabet"
        >
          <option
            v-for="(item, index) in alphabets"
            :key="index"
            :value="index"
            >{{ item }}</option
          >
        </select>
        <input
          type="text"
          maxlength="3"
          class="plate-main plate-commons"
          @change="updateValue()"
          v-model="plate.main"
        />
        <input
          type="text"
          maxlength="2"
          class="plate-city"
          @change="updateValue()"
          v-model="plate.twoDigit"
        />
      </div>
      <span
        class="invalid-feedback"
        :style="`display: ${!isValid ? 'inline-block' : 'none'}`"
        >پلاک اشتباه است</span
      >
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {},
  },
  data() {
    return {
      inputValue: "",
      error: "پلاک اشتباه است",
      isValid: true,
      plate: {
        twoDigit: "",
        alphabet: 20,
        main: "",
        cityNumber: "",
      },
      alphabets: [
        "الف",
        "ب",
        "پ",
        "ت",
        "ث",
        "ج",
        "چ",
        "ح",
        "خ",
        "د",
        "ذ",
        "ر",
        "ز",
        "ش",
        "س",
        "ش",
        "ص",
        "ض",
        "ط",
        "ظ",
        "ع",
        "غ",
        "ف",
        "ق",
        "ک",
        "گ",
        "ل",
        "م",
        "ن",
        "و",
        "ه",
        "ی",
      ],
    };
  },
  watch: {
    value: {
      immediate: true,   
      handler(_value) {
        if (!_value) return;

        this.inputValue = _value;
        this.plate = this.convertStringToPlate(_value);
      },
    },
  },
  computed: {},
  methods: {
    validate() {
      let _this = this
      return new Promise(function(resolve, reject) {
        if (
          _this.plate.twoDigit.length == 2 &&
          _this.plate.alphabet >= 0 &&
          _this.plate.main.length == 3 &&
          _this.plate.cityNumber.length == 2
        ) {
          _this.isValid = true;
          resolve(true);
        }
        _this.isValid = false;
        reject(false);
      });
    },
    resetValidation() {
      this.isValid = true;
    },
    updateValue() {
      let alphabet = this.alphabets[this.plate.alphabet];
      this.$emit(
        "input",
        `${this.plate.twoDigit}${alphabet}${this.plate.main}ایران${this.plate.cityNumber}`
      );
    },
    convertStringToPlate(_string) {
      const regex = /[\u0621-\u0628\u062A-\u063A\u0641-\u0642\u0644-\u0648\u064E-\u0651\u0655\u067E\u0686\u0698\u0020\u2000-\u200F\u2028-\u202F\u06A9\u06AF\u06BE\u06CC\u0629\u0643\u0649-\u064B\u064D\u06D5\s]+/;
      let string = String(_string).replace("ایران", "");
      let alphabetsValue = string.match(regex) ? string.match(regex)[0] : "";
      string = String(string).replace(regex, "");
      let alphabetIndex = this.alphabets.indexOf(alphabetsValue);
      let twoDigits = string.substring(0, 2);
      let main = string.substring(2, 5);
      let cityNumber = string.substring(5, 7);

      return {
        twoDigit: twoDigits,
        alphabet: alphabetIndex,
        main: main,
        cityNumber: cityNumber,
      };
    },
  },
};
</script>
<style scoped>
.plate {
  background: url("/img/plate.jpg");
  background-size: contain;
  background-repeat: no-repeat;
  height: 46px;
  width: 276px;
  position: relative;
}
.plate-two {
  left: 1.8em;
  width: 2.8em;
}
.plate-alphabet {
  left: 4.7em;
  width: 3.5em;
}
.plate-main {
  right: 8.9em;
  width: 4em;
}
.plate-city {
  position: absolute;
  right: 5.3em;
  height: 2.1em;
  width: 3.1em;
  top: 13px;
  text-align: center;
}
.plate-commons {
  top: 0.344em;
  height: 2.8em;
  position: absolute;
  text-align: center;
}
</style>
